import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import { Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type SupplierFallbackVariant = 'no-ddt' | 'failed';

interface SupplierFallbackDialogProps {
  open: boolean;
  variant: SupplierFallbackVariant;
  onChooseFromList: () => void;
  onCreateNew: () => void;
  onClose: () => void;
}

const TITLE_KEYS: Record<SupplierFallbackVariant, string> = {
  'no-ddt': 'supplierFallbackNoDdtTitle',
  failed: 'supplierFallbackFailedTitle',
};

const MESSAGE_KEYS: Record<SupplierFallbackVariant, string> = {
  'no-ddt': 'supplierFallbackNoDdtMessage',
  failed: 'supplierFallbackFailedMessage',
};

export function SupplierFallbackDialog({
  open,
  variant,
  onChooseFromList,
  onCreateNew,
  onClose,
}: SupplierFallbackDialogProps) {
  const { t } = useTranslation('goodsReceiving');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t(TITLE_KEYS[variant])}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t(MESSAGE_KEYS[variant])}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<FormatListBulletedOutlinedIcon />}
            onClick={onChooseFromList}
            fullWidth
            sx={{ minHeight: 48 }}
          >
            {t('supplierFallbackChooseFromList')}
          </Button>
          <Button
            variant="outlined"
            startIcon={<AddBusinessOutlinedIcon />}
            onClick={onCreateNew}
            fullWidth
            sx={{ minHeight: 48 }}
          >
            {t('supplierFallbackCreateNew')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
